module.exports = __webpack_public_path__ + "static/media/albertoa.23732823.jpg";